import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { ArrowRight, BarChart3 } from 'lucide-react';
import { ShareButtons } from './ShareButtons';
import { PollInfo } from './PollInfo';
import { supabase } from '../../lib/supabase';
import { Header } from '../Header';
import { Toast } from '../Toast/Toast';
import { useToast } from '../../hooks/useToast';

export function SharePoll() {
  const { pollId } = useParams<{ pollId: string }>();
  const navigate = useNavigate();
  const { toast, showToast, hideToast } = useToast();
  const [pollName, setPollName] = useState('');

  useEffect(() => {
    const fetchPoll = async () => {
      if (!pollId) return;

      try {
        const { data: poll, error } = await supabase
          .from('polls')
          .select('name')
          .eq('id', pollId)
          .single();

        if (error) throw error;
        if (!poll) throw new Error('Poll not found');

        setPollName(poll.name);
      } catch (error) {
        console.error('Error fetching poll:', error);
        showToast('Failed to load poll details');
        navigate('/');
      }
    };

    fetchPoll();
  }, [pollId, navigate, showToast]);

  const handleProceedToVote = () => {
    navigate(`/${pollId}`);
  };

  const handleViewResults = () => {
    navigate(`/${pollId}/results`);
  };

  if (!pollId || !pollName) return null;

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900">
      <Header />
      <div className="w-full max-w-md mx-auto p-6">
        <PollInfo pollCode={pollId.toLowerCase()} pollUrl={window.location.origin + '/' + pollId} />
        <ShareButtons pollUrl={window.location.origin + '/' + pollId} pollName={pollName} />
        <div className="space-y-3">
          <button
            onClick={handleProceedToVote}
            className="w-full bg-blue-500 text-white py-3 rounded-lg hover:bg-blue-600 flex items-center justify-center gap-2"
          >
            Vote in this poll
            <ArrowRight className="w-5 h-5" />
          </button>
          <button
            onClick={handleViewResults}
            className="w-full bg-gray-100 text-gray-700 dark:bg-gray-700 dark:text-gray-200 py-3 rounded-lg hover:bg-gray-200 dark:hover:bg-gray-600 flex items-center justify-center gap-2"
          >
            View Results
            <BarChart3 className="w-5 h-5" />
          </button>
        </div>
      </div>
      {toast && <Toast message={toast} onDismiss={hideToast} />}
    </div>
  );
}